import axios from 'axios'
import store from '../store'
import router from '../router'
// import https from 'https'

export default () => {
  let http = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    headers: {
      'Accept': 'application/json'
    },
    withCredentials: true
  })

  if (store.getters.LOGGED_IN) {
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.BEARER_TOKEN
  }

  // Interceptor de respuesta para manejar errores globalmente
  http.interceptors.response.use(
    response => response,
    (error) => {
      if (!error.response) {
        // Error de red o timeout
        return Promise.reject(error)
      }

      const { status, data } = error.response

      switch (status) {
        case 401:
          // Token expirado o no autorizado
          store.dispatch('LOGOUT')
          router.push({ name: 'Login' })
          break
        case 403:
          // Error de permisos - no mostrar toast aquí, dejar que lo maneje el componente
          // Agregar información adicional al error para que el componente sepa que es un error de permisos
          error.isPermissionError = true
          error.permissionMessage = data?.message || 'No tienes permisos para realizar esta acción.'
          break
        case 500:
          // Error del servidor
          console.error('Error del servidor:', error)
          break
        default:
          // Otros errores
          break
      }

      return Promise.reject(error)
    }
  )

  return http
}
